import { lazy } from 'react';

export const ArticlesNewsPage = lazy(() => import('./ArticlesNewsPage'));
